import { AlertTriangle, ExternalLink } from 'lucide-react';
import React from 'react';
import { Link } from 'react-router-dom';

import type { MiniTortClaimDetail, MiniTortSubmission } from '../types';
import { MiniTortStage } from '../types';

interface ClaimBannersProps {
  claim: MiniTortClaimDetail;
  submission: MiniTortSubmission | null;
}

export const ClaimBanners: React.FC<ClaimBannersProps> = ({ claim, submission }) => (
  <>
    {/* Escalation banner */}
    {claim.converted_intake_id && (
      <div className="flex items-center gap-3 rounded-lg border-2 border-indigo-300 bg-indigo-50 px-4 py-3 dark:border-indigo-700 dark:bg-indigo-900/20">
        <ExternalLink className="h-5 w-5 shrink-0 text-indigo-600 dark:text-indigo-400" />
        <div className="flex-1">
          <p className="text-sm font-semibold text-indigo-800 dark:text-indigo-200">Escalated to Intake</p>
          <p className="text-xs text-indigo-700 dark:text-indigo-300">
            {submission?.was_injured
              ? 'Triggered by claimant reporting injury on submission form.'
              : 'Triggered by injury signals detected during claim processing.'}
          </p>
          <Link
            to={`/matters/${claim.converted_intake_id}`}
            className="mt-1 inline-flex items-center gap-1 text-xs font-semibold text-indigo-700 underline hover:text-indigo-900 dark:text-indigo-300 dark:hover:text-indigo-100"
          >
            <ExternalLink className="h-3 w-3" />
            View Intake Matter {claim.converted_intake_id.slice(0, 8)}
          </Link>
        </div>
      </div>
    )}

    {/* Injury banner — only when NOT yet escalated */}
    {claim.injury_detected && !claim.converted_intake_id && (
      <div className="flex items-center gap-3 rounded-lg border border-amber-200 bg-amber-50 px-4 py-3 dark:border-amber-800 dark:bg-amber-900/20">
        <AlertTriangle className="h-5 w-5 text-amber-600 dark:text-amber-400" />
        <div>
          <p className="text-sm font-semibold text-amber-800 dark:text-amber-200">Injury Detected</p>
          <p className="text-xs text-amber-700 dark:text-amber-300">
            This claimant may have been injured. Intake team should perform outbound call.
          </p>
        </div>
      </div>
    )}

    {/* Rejection reason */}
    {claim.stage === MiniTortStage.REJECTED && claim.rejection_reason && (
      <div className="rounded-lg border border-red-200 bg-red-50 px-4 py-3 dark:border-red-800 dark:bg-red-900/20">
        <p className="text-sm font-semibold text-red-800 dark:text-red-200">Rejection Reason</p>
        <p className="mt-1 text-sm text-red-700 dark:text-red-300">{claim.rejection_reason}</p>
      </div>
    )}
  </>
);
